module.exports = __webpack_public_path__ + "media/ringtone.74dd1325.mp3";